<div class="ai-chat-options" *ngIf="getOptions().length">
  <p *ngIf="optionsData?.message" class="ai-chat-options-message">
    {{ optionsData.message }}
  </p>

  <div class="ai-chat-options-list">
    <button
      type="button"
      class="ai-chat-option-btn"
      *ngFor="let option of getOptions()"
      (click)="selectOption(option)"
    >
      {{ getLabel(option) }}
    </button>
  </div>
</div>
